// Which Guide article answers "How do I use this?" for each screen, per role.
import api from "@/lib/api";

let visible = null;
// Slugs the signed-in person can read (fetched once per sign-in).
export function visibleSlugs(userId) {
  if (!visible || visible.userId !== userId) {
    visible = { userId, promise: api.get("/help/articles").then((r) => new Set((r.data.items || []).map((a) => a.slug))).catch(() => new Set()) };
  }
  return visible.promise;
}
export function helpRole(user) {
  const r = (user?.role || "").toLowerCase();
  if (r === "super_admin" || r === "admin") return "admin";
  if (r === "media_buyer") return "media_buyer";
  if (["buyer", "client_admin", "client_employee"].includes(r)) return "buyer";
  if (["vendor", "affiliate_admin", "affiliate_employee"].includes(r)) return "vendor";
  return "employee";
}

// [pattern, slug for internal staff, { per-role overrides }]
const ROUTES = [
  [/^\/$/, "admin-dashboard", { employee: "employee-getting-started", vendor: "vendor-dashboard", buyer: "buyer-dashboard" }],
  [/^\/leads\/new$/, "admin-new-lead"],
  [/^\/leads\/[^/]+\/report$/, "admin-returns", { vendor: "vendor-returns", buyer: "buyer-returns" }],
  [/^\/leads\/[^/]+$/, "admin-lead-detail", { vendor: "vendor-leads", buyer: "buyer-lead-detail" }],
  [/^\/leads$/, "admin-leads", { vendor: "vendor-leads", buyer: "buyer-lead-list" }],
  [/^\/bad-leads/, "admin-returns", { vendor: "vendor-returns", buyer: "buyer-returns" }],
  [/^\/downloads$/, "admin-downloads", { buyer: "buyer-downloads" }],
  [/^\/replacement-vouchers$/, "admin-vouchers", { buyer: "buyer-vouchers" }],
  [/^\/employees/, "admin-employees", { vendor: "vendor-team", buyer: "buyer-team-access" }],
  [/^\/clients/, "admin-clients"],
  [/^\/affiliates$/, "admin-affiliates"],
  [/^\/campaigns$/, "admin-campaigns"],
  [/^\/csv-upload$/, "admin-csv-upload"],
  [/^\/integrations$/, "admin-integrations"],
  [/^\/form-integrations$/, "admin-form-adapters"],
  [/^\/quality-alerts$/, "admin-quality-alerts"],
  [/^\/scheduled-reports$/, "admin-scheduled-reports"],
  [/^\/delivery$/, "admin-delivery-destinations"],
  [/^\/delivery-health$/, "admin-delivery-health"],
  [/^\/invoices$/, "admin-invoices"],
  [/^\/email-intake$/, "admin-email-intake"],
  [/^\/mfa-policies$/, "admin-mfa-policies"],
  [/^\/settings\/platform$/, "admin-platform-settings"],
  [/^\/admin\/code-health$/, "admin-code-health"],
  [/^\/admin\/affiliate-quality$/, "admin-affiliate-quality"],
  [/^\/audit$/, "admin-audit-log"],
  [/^\/admin\/landing-pages\/custom/, "admin-lp-editor", { media_buyer: "mb-landing-pages" }],
  [/^\/admin\/landing-pages$/, "admin-landing-pages", { media_buyer: "mb-landing-pages" }],
  [/^\/admin\/lp-analytics$/, "admin-lp-analytics"],
  [/^\/admin\/marketplace$/, "admin-marketplace"],
  [/^\/admin\/margin$/, "admin-margin"],
  [/^\/admin\/demand-map$/, "admin-demand-map"],
  [/^\/admin\/pixels$/, "admin-pixels", { media_buyer: "mb-pixels" }],
  [/^\/admin\/prospect-engagement$/, "admin-prospect-engagement"],
  [/^\/admin\/failed-deliveries$/, "admin-failed-deliveries"],
  [/^\/admin\/tracking-approvals$/, "admin-custom-tracking"],
  [/^\/admin\/postbacks$/, "postbacks-overview"],
  [/^\/postbacks$/, "postbacks-overview"],
  [/^\/media-buyer\/custom-tracking$/, "admin-custom-tracking", { media_buyer: "mb-custom-tracking" }],
  [/^\/media-buyer\//, "mb-attribution"],
  [/^\/results$/, "admin-traffic-results", { media_buyer: "mb-traffic-results" }],
  [/^\/timeline$/, "my-activity"],
  [/^\/profile$/, "profile-and-security"],
  [/^\/buyer$/, "buyer-portal"],
  [/^\/vendor$/, "vendor-portal"],
];

export function helpSlugFor(pathname, user) {
  const role = helpRole(user);
  const hit = ROUTES.find(([re]) => re.test(pathname));
  if (!hit) return null;
  const [, slug, overrides = {}] = hit;
  return overrides[role] || slug;
}
